
import Button from '../base/Button';

export default function Header() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/37cb603fe6f888fc4eccfb549fcd2cba/b0e3db6063b1faa95b4b7b4b71a4b372.png" 
              alt="My Marketing Horizon Logo" 
              className="h-14 w-auto"
            />
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-orange-500 cursor-pointer transition-colors"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-orange-500 cursor-pointer transition-colors"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="text-gray-700 hover:text-orange-500 cursor-pointer transition-colors"
            >
              Testimonials
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-orange-500 cursor-pointer transition-colors"
            >
              Contact
            </button>
          </nav>
          
          <Button 
            onClick={() => scrollToSection('contact')}
            variant="primary"
            size="sm"
          >
            Get Started
          </Button>
        </div>
      </div>
    </header>
  );
}
